import React from 'react';

const MetricCard = ({ title, value, text }) => {
    return (
        <div className="col-md-4 mb-3">
            <div className="card card-metric shadow-sm text-center">
                <div className="card-body">
                    <h2 className="card-title">{value}</h2>
                    <p className="card-text fs-5">{text}</p>
                </div>
            </div>
        </div>
    );
};

export default MetricCard;